module.exports = __webpack_public_path__ + "img/bt.23aa9f95.svg";